<template>
  <section v-if="isDev">
		<div v-if="storagesWithProducts">
			<div v-for="str in storagesWithProducts" :key="str.name">{{str.name}}</div>
		</div>
    <p v-if="movingType">
      Moving Type: <strong>{{ movingType }}</strong>
    </p>
    <p v-if="startDate">
      Order Date: <strong>{{ startDate | date }}</strong>
    </p>
    <p v-if="endDate">
      Order Date: <strong>{{ endDate | date }}</strong>
    </p>
    <p v-if="shippingCountry">
      Order Country: <strong>{{ shippingCountry }}</strong>
    </p>
    <p v-if="orderableProducts.length">
			Items:
			<ul>
				<li v-for="item in orderableProducts" :key="item.id">
					<span class="max">{{ item.translated_name || item.name }} - {{ item.id }} x {{ item.quantity }} = {{ (item.quantity * item.total_price) | price}} {{item.currency}}</span><br />
				</li>
			</ul>
		</p>
		<p v-if="deliveryProduct.length">Delivery:
			<ul>
				<li v-for="item in deliveryProduct" :key="item.id">
					<span class="max">{{ item.translated_name || item.name }} - {{ item.id }} x {{ item.quantity }} = {{ (item.quantity * item.total_price) | price}} {{item.currency}}</span><br />
				</li>
			</ul>
		</p>
		<p v-if="capacityPoints">
      Capacity Points: <strong>{{ capacityPoints }}</strong>
    </p>
		<p v-if="pickupPoints">
      Pickup Points: <strong>{{ pickupPoints }}</strong>
    </p>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import currency from 'currency.js';
import date from 'date-and-time'
import Storage from '@/helpers/localStorage'

export default {
  name: 'InfoHelper',
  data() {
    return {
			isDev: false
    }
  },
  computed: {
    ...mapState('cart', ['movingType', 'startDate', 'deliveryProduct']),
		...mapGetters('cart', ['orderableProducts','endDate','capacityPoints','pickupPoints']),
		...mapGetters('storages', {storagesWithProducts: 'availableForOrder'}),
		...mapState('user', ['shippingCountry'])
  },
	created() {
		this.getParameters();
	},
	methods: {
		getParameters() {
			const url_string = window.location.href
			const url = new URL(url_string);
			this.isDev = url.searchParams.get("isdev") == 1 || Storage.getIsDev();
		}
	},
  filters: {
    date(value) {
      if (!value) return ''
      return date.format(value, 'YYYY-MM-DD')
    },
		price(value) {
      if (!value) return ''
			return currency(value);
		}
  },
}
</script>

<style lang="scss" scoped>
section {
  position: fixed;
  top: 36px;
  right: 0;
  padding: 10px;
  background: #000;
  color: #fff;
  text-align: left;
  z-index: 999;
  width: 300px !important;
	font-size: 16px;
	line-height: 1.75;

	ul {
		font-size: 12px;
	}
}
</style>
